<div class="meta-config-dialog">
  <app-meta-config 
    [elemId]="data.elemId"
    [styleId]="data.styleId" 
    [CSDElementRef]="data.CSDElementRef"
    [eType]="data.eType"
    (closePanel)="onClose()">
  </app-meta-config>
</div>